import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h3 className="font-heading text-lg font-semibold text-background-50 mb-4">人渣游戏深度解析</h3>
            <p className="text-sm text-background-400 leading-relaxed">
              致力于为玩家提供最全面的人渣游戏攻略、剧情分析和行业讨论。探索争议背后的真相，做出明智的游戏选择。
            </p>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">内容分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">快速链接</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">关于我们</Link></li>
              <li><Link to="/category/wanfa-gonglue" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">玩法攻略</Link></li>
              <li><Link to="/category/juqing-jiexi" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">剧情解析</Link></li>
              <li><Link to="/category/daode-zhengyi" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">道德争议</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">联系我们</h4>
            <p className="text-sm text-background-400 leading-relaxed mb-3">
              如有任何问题或建议，欢迎通过关于我们页面的联系表单与我们取得联系。
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-1 text-sm text-accent-400 hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap"
            >
              前往联系 <i className="ri-arrow-right-line text-xs" />
            </Link>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 人渣游戏深度解析. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">
              <i className="ri-wechat-line text-lg" />
            </a>
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">
              <i className="ri-weibo-line text-lg" />
            </a>
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">
              <i className="ri-bilibili-line text-lg" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}